import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../components/LanguageSwitcher';

export function PrivacyPage() {
  const { t } = useTranslation();

  const sections = [
    { title: t('privacyPage.s1title'), body: t('privacyPage.s1body') },
    { title: t('privacyPage.s2title'), body: t('privacyPage.s2body') },
    { title: t('privacyPage.s3title'), body: t('privacyPage.s3body') },
    { title: t('privacyPage.s4title'), body: t('privacyPage.s4body') },
  ];

  return (
    <div className="min-h-screen p-6 md:p-8 max-w-2xl mx-auto">
      <div className="flex justify-between items-center mb-2">
        <Link to="/settings" className="text-sm text-daynote-muted hover:text-daynote-text">
          {t('privacyPage.back')}
        </Link>
        <LanguageSwitcher />
      </div>
      <h1 className="font-display text-4xl mt-6 mb-8">{t('privacyPage.title')}</h1>
      <div className="prose prose-invert text-sm text-daynote-muted space-y-6 leading-relaxed">
        {sections.map((s) => (
          <section key={s.title}>
            <h2 className="font-display text-lg text-daynote-text mb-2">{s.title}</h2>
            <p>{s.body}</p>
          </section>
        ))}
        <section>
          <h2 className="font-display text-lg text-daynote-text mb-2">{t('privacyPage.s5title')}</h2>
          <p>
            {t('privacyPage.s5body')}{' '}
            <a href="mailto:feedback@daynote.app" className="text-daynote-accent underline">
              feedback@daynote.app
            </a>
          </p>
        </section>
        <p className="text-xs text-daynote-text/40 pt-4">{t('privacyPage.lastUpdated')}</p>
      </div>
    </div>
  );
}
